import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/paciente`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        autocomplete(queryParms = {}) {

            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms = {}) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getDomicilio(queryParms = {}) {

            return repository.get(`${baseUrl}/domicilio?${urlUtil.serialize(queryParms)}`)
        },
        validCNS(queryParms = {}) {

            return repository.get(`${baseUrl}/valida-cns?${urlUtil.serialize(queryParms)}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        show(id, queryParms = {}) {

            return repository.get(`${baseUrl}/${id}?${urlUtil.serialize(queryParms)}`)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        store(params, queryParms = {}) {

            return repository.post(`${baseUrl}?${urlUtil.serialize(queryParms)}`, params)
        },
        update(id, params, queryParms = {}) {

            return repository.put(`${baseUrl}/${id}?${urlUtil.serialize(queryParms)}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
        bloquear(id) {

            return repository.put(`${baseUrl}/${id}/bloquear`)
        },
        desbloquear(id) {

            return repository.put(`${baseUrl}/${id}/desbloquear`)
        },
        saveResidente(params) {
            return repository.post(`${baseUrl}/save-residente`, params);
        },
        removeResidente(cidadaoId, queryParms = {}) {

            return repository.delete(`${baseUrl}/remove-residente/${cidadaoId}?${urlUtil.serialize(queryParms)}`)
        },
        getNucleosFamiliares(queryParms = {}) {

            return repository.get(`${baseUrl}/nucleo-familiar?${urlUtil.serialize(queryParms)}`)
        },
        createNucleoFamiliar(params) {

            return repository.post(`${baseUrl}/nucleo-familiar`, params)
        },
        renameNucleoFamiliar(nucleoFamiliarId, params) {

            return repository.put(`${baseUrl}/nucleo-familiar/${nucleoFamiliarId}`, params)
        },
        deleteNucleoFamiliar(nucleoFamiliarId) {

            return repository.delete(`${baseUrl}/nucleo-familiar/${nucleoFamiliarId}`)
        },
        removeNucleoFamiliar(cidadaoId, queryParms = {}) {

            return repository.delete(`${baseUrl}/remove-nucleo-familiar/${cidadaoId}?${urlUtil.serialize(queryParms)}`)
        },
        addMembroNucleoFamiliar(params) {

            return repository.post(`${baseUrl}/nucleo-familiar/membro`, params)
        },
        getHistoricoNucleoFamiliar(nucleoFamiliarId) {

            return repository.get(`${baseUrl}/nucleo-familiar/${nucleoFamiliarId}/historico`)
        },
        getPrintFormModelData(id) {

            return repository.get(`${baseUrl}/${id}/print`)
        },
    }
}